const features = [
  {
    icon: "ri-search-eye-line",
    color: "from-blue-500 to-indigo-500",
    title: "招商线索挖掘",
    desc: "基于产业链图谱精准定位目标企业，多维数据建模预测投资意愿，监测竞品园区动态把握企业动向。",
    tags: ["产业链匹配", "投资意愿预测", "竞品监测"],
  },
  {
    icon: "ri-brain-line",
    color: "from-amber-500 to-orange-400",
    title: "智能项目评估",
    desc: "需求结构化（产业方向、空间需求、投资预算、配套要求）与供给数字化（可用空间、租售价格、配套设施、政策权益）智能匹配评分。",
    tags: ["需求结构化", "供给数字化", "匹配评分"],
  },
  {
    icon: "ri-loop-left-line",
    color: "from-emerald-500 to-green-400",
    title: "落地跟踪闭环",
    desc: "全生命周期数字化跟踪：线索→洽谈→签约→落地建设→投产运营，项目进度透明可视，节点时效可控。",
    tags: ["线索", "洽谈", "签约", "投产"],
  },
  {
    icon: "ri-radar-line",
    color: "from-violet-500 to-purple-400",
    title: "企业动态监测",
    desc: "多维度数据实时监测，掌握企业经营动态、扩产意向、投资布局变化，辅助招商决策。",
    tags: ["经营监测", "扩产意向", "投资布局"],
  },
  {
    icon: "ri-alarm-warning-line",
    color: "from-rose-500 to-red-400",
    title: "流失风险预警",
    desc: "多因子风险识别，提前预警企业流失风险，分级推送风险信息，闭环跟进处置，确保项目不流失。",
    tags: ["风险识别", "分级预警", "闭环处置"],
  },
  {
    icon: "ri-shield-check-line",
    color: "from-teal-500 to-cyan-400",
    title: "风险预警处置",
    desc: "风险分级推送，闭环跟进处置，解决项目进度不透明、流失预警滞后问题，提升落地效率。",
    tags: ["分级推送", "闭环跟进", "效率提升"],
  },
];

const dataSupport = [
  { icon: "ri-building-4-line", title: "产业园区", desc: "空间供给" },
  { icon: "ri-hotel-line", title: "商务楼宇", desc: "载体资源" },
  { icon: "ri-database-2-line", title: "企业数据", desc: "全量画像" },
  { icon: "ri-map-2-line", title: "POI全量", desc: "配套分析" },
  { icon: "ri-map-pin-line", title: "标准地址", desc: "精准定位" },
];

export default function IMFeatures() {
  return (
    <section className="py-20 px-8" style={{ background: "#f5f4fb" }}>
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Platform Features</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">六大核心招商管理功能</h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">招商线索、项目评估、落地跟踪、企业监测、风险预警、闭环处置，覆盖招商全链路</p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-slate-100 hover:border-indigo-200 transition-all cursor-pointer group">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br ${f.color} mb-4 group-hover:scale-105 transition-transform`}>
                <i className={`${f.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-slate-800 font-semibold text-base mb-2">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">{f.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {f.tags.map((t) => (
                  <span key={t} className="text-xs bg-indigo-50 border border-indigo-100 text-indigo-600 px-2 py-0.5 rounded-full">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Data support section - dark banner */}
        <div className="mt-12 bg-gradient-to-r from-[#0a1e3a] to-[#0d2a4a] rounded-2xl px-8 py-6 flex items-center justify-between">
          <div>
            <div className="text-blue-300 text-xs font-semibold tracking-widest uppercase mb-1">Data Support</div>
            <div className="">
              <h3 className="text-white font-bold text-lg">多维度数据支撑 · 精准招商决策</h3>
            </div>
          </div>
          <div className="flex items-center gap-6">
            {dataSupport.map((d) => (
              <div key={d.title} className="flex flex-col items-center text-center bg-white/10 rounded-xl px-4 py-3 border border-white/15 min-w-[90px]">
                <div className="w-8 h-8 flex items-center justify-center text-blue-300 mb-2">
                  <i className={`${d.icon} text-xl`}></i>
                </div>
                <div className="text-white font-semibold text-sm">{d.title}</div>
                <div className="text-white/50 text-xs mt-0.5">{d.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
